import { Maybe as HygraphMaybe, Statistic as HygraphProps } from '@/lib/types';

import { StatisticProps } from '@/components/statistic';

export default function statisticTransformer(
  hygraphProps: HygraphMaybe<HygraphProps> | undefined
) {
  if (!hygraphProps) {
    return undefined;
  }
  return {
    amount: hygraphProps.amount,
    unit: hygraphProps.unit,
    label: hygraphProps.label,
  } as StatisticProps;
}
